const translations = {
    apiError: 'Something went wrong. Please try again.',
    title: 'Edit Controller'
};

export default translations;
